import React from 'react'

import { useAppSelector } from '../../../store/hooks'
import { selectAuthCompanySlice } from '../../../store/auth-company-slice'
import { SubscriptionPlanEnum } from '@vacationtracker/shared/types/company'

import StripeBillingPage from './stripe'
import MicrosoftBillingPage from './microsoft'
import ADPBillingPage from './adp'

const BillingPage: React.FC = () => {
  const { authCompany } = useAppSelector(selectAuthCompanySlice)

  if (authCompany?.billing?.paymentProcessor === 'microsoft-billing') {
    return <MicrosoftBillingPage />
  } else if (authCompany?.billing?.paymentProcessor === 'adp') {
    return <ADPBillingPage />
  } else {
    return <StripeBillingPage showFreemiumPlan={authCompany?.plan === SubscriptionPlanEnum.freemium} />
  }
}

export default BillingPage
